// Imports
import {
  Base, DataTypes, SubmitTypes, ErrorTypes
} from '@mixins/forms'
import { mapState } from 'vuex'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { SpaCheckoutSubmit: submitType } = SubmitTypes
const { CheckOutError: errorHandling } = ErrorTypes

// Options
const options = {
  name: 'SpaCheckoutFormHandler',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: true,
    validation: true,
    externalValidation: true,
    submit: { events: {} },
    error: true
  }
}

// Component
export default {
  name: options.name,
  mixins: [
    Base(options)
  ],
  computed: {
    ...mapState('spaSoft', ['selectedItinerary', 'hotelCode', 'propertyData']),
  },
  methods: {
    /**
    * Transforms the data before passing it
    * to the submit action.
    */
    async transformData(data) {
      if (!this.selectedItinerary) {
        throw new Error('No itinerary selected')
      }
      return {
        timetableOption: {
          guestAvailabilities: this.selectedItinerary?.guestAvailabilities || []
        },
        termsAndConditions: data.termsAndConditions,
        cardHolderName: data.cardHolderName,
        cardNumber: data.cardNumber,
        expirationDate: data.cardExpirateDate,
        hotelCode: this.hotelCode,
        propertyTimezone: this.propertyData?.propertyTimezone
      }
    },
    /**
    * Transforms the response.
    */
    async transformResponse(data) {
      this.$logger.debug('redirectUrl: ', this.redirectUrl)
      this.$logger.debug('data: ', data)

      if (this.redirectUrl) window.location.replace(this.redirectUrl)
      return data
    },
  }
}
